webpackJsonp([211306052543826],{

/***/ 743:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/august-host-exclusives-look/"},"excerpt":"In a world where you can be anything, be kind! Kindness is free! Let’s sprinkle it everywhere like confetti! Check out this beautiful sneak…","timeToRead":1,"frontmatter":{"title":"Kindness Matters","category":"hostess exclusives"}}}]},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"category":"hostess exclusives"}}

/***/ })

});


// WEBPACK FOOTER //
// path---category-hostess-exclusives-cbba60cb3754ded7e3e9.js